import CancellationLossAversionModal from './CancellationLossAversionModal';

export default CancellationLossAversionModal;
